import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import UsersApi from "../../../Classes/API/UsersApi";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DateTimePicker from "react-datetime-picker";

import AppointmentsApi from "../../../Classes/API/Appointments/AppointmentsApi";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";

import SearchUserModel from "../../../Classes/Models/Requests/Users/SearchUser";
import SearchAccountingSessions from "../../../Classes/Models/Requests/Accounting/SearchAccountingSession";
import StringIntSearchReq from "../../../Classes/Models/Requests/StringIntSearchReq";
import GetAppointmentDayReq from "../../../Classes/Models/Requests/Appointments/GetAppointmentDayReq";
import AddManyToManyReq from "../../../Classes/Models/Requests/AddManyToManyReq";
import CreateAppointmentWithHoursReq from "../../../Classes/Models/Requests/Appointments/CreateAppointmentWithHoursReq";

import { Navigate, useLocation, useNavigate } from "react-router-dom";

import AsyncSelect from "react-select/async";
import MDButton from "components/MDButton";
import AddTherapistToAccSession from "layouts/AccountingSessions/AccountingSessionDetails/AccSessionTherapists/AddTherapistToAccSession";

const index = () => {
  let navigate = useNavigate();

  const { state } = useLocation();

  const [AccSessionAutoText, SetAccSessionAutoText] = useState();
  const [PatientAutoText, SetPatientAutoText] = useState();

  const [PaitentsSearch, SetPatientsSearch] = useState("");
  const [AppDaySearch, SetAppDaySearch] = useState("");
  const [AppHourSearch, SetAppointmentHourSearch] = useState("");
  const [AccSessionsSearch, SetAccouningSessionsSearch] = useState("");
  const [SearchDay, SetSearchDay] = useState(new Date());

  const [AccSession, SetAccSession] = useState({});
  const [Patient, SetPatient] = useState({});
  const [AppDay, SetAppDay] = useState({});
  const [AppHours, SetAppHours] = useState([]);
  const [SelectedHour, SetSelectedHour] = useState(-1);

  const [AppAccSessThObj, SetAppAccSessThObj] = useState({});

  const [DayLoaded, setDayLoaded] = useState(false);

  const [CreateIsReady, setCreateIsReady] = useState(false);

  const [ShowGoToHour, setShowGoToHour] = useState(false);

  useEffect(async () => {
    if (state && state.AccSession) {
      let getReq = new StringIntSearchReq();
      getReq.SearchInt = state.AccSession.id;
      let res = await SessionsApi.GetAccountingSessionById(getReq);

      if (res.status == "Success") {
        SetAccSession(res.data);
        SetPatient(res.data.getPatient);
      } else {
        Swal.fire({
          title: "Error",
          text: "Error getting auto selected accounting session",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    }
  }, [state]);

  const CreateAppointment = async () => {
    let AppHourArr = [];

    AppHourArr.push(AppAccSessThObj.SelectedAppHour.id);

    let req = new CreateAppointmentWithHoursReq();
    req.IsConfirmed = false;
    req.PatientId = Patient.id;
    req.AccountingSessionId = AccSession.id;
    req.SessionId = AccSession.sessionId;
    req.HourIds = AppHourArr;
    req.IsSplit = false;
    req.IsFirstHalf = false;
    req.IsHalfDuration = false;
    req.SessionId = AccSession.sessionId;

    console.log(req);
    let res = await AppointmentsApi.CreateAppointmentWithHours(req);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success");
      setCreateIsReady(false);
      setShowGoToHour(true);
    }
  };

  const GoToHour = () => {
    navigate("/Appointments/AppHourDetails", {
      state: {
        AppHour: AppAccSessThObj.SelectedAppHour,
      },
    });
  };

  useEffect(() => {
    let createReady = true;
    if (Object.keys(AppAccSessThObj).length < 1) {
      createReady = false;
    }
    if (!AppAccSessThObj.IsSelected || !AppAccSessThObj.SelectedAppHour) {
      createReady = false;
    }
    setCreateIsReady(createReady);
  }, [AppAccSessThObj]);

  const HandleSelectedHourChange = () => {
    let tempAppAccSessThObj = {
      isIn: false,
      SelectedHour: SelectedHour,
      SelectedAppHour: undefined,
      IsSelected: false,
    };
    AppDay.getTherapists.forEach((t) => {
      if (t.getTherapist.id == AccSession.getTherapist.id) {
        tempAppAccSessThObj.isIn = true;
        tempAppAccSessThObj.SelectedHour = SelectedHour;
        tempAppAccSessThObj.SelectedAppHour = t.getAppointmentHours.find(
          (o) => o.hour == SelectedHour
        );
        tempAppAccSessThObj.IsSelected = tempAppAccSessThObj.SelectedAppHour ? true : false;
      }
    });
    console.log(tempAppAccSessThObj);

    SetAppAccSessThObj(tempAppAccSessThObj);
  };

  useEffect(() => {
    if (
      AccSession &&
      Object.keys(AccSession).length > 0 &&
      Object.keys(AppDay).length > 0 &&
      AccSession.getTherapist
    ) {
      HandleSelectedHourChange();
    }
  }, [SelectedHour, AccSession, AppDay]);

  useEffect(() => {
    if (Object.keys(AppDay).length) {
      setDayLoaded(true);
    }
  }, [AppDay]);

  useEffect(() => {
    if (Object.keys(AccSession).length) {
      SetPatient(AccSession.getPatient);
    }
  }, [AccSession]);

  const AddTherapistToAppointmentDay = async (TherapistId, AppDayId) => {
    let addReq = new AddManyToManyReq();
    addReq.Id1 = AppDayId;
    addReq.Id2 = TherapistId;
    let res = await AppointmentsApi.AddTherapistToAppointmentDay(addReq);
    if (res.status == "Success") {
      await GetAppDay();
    }
  };

  const AddTherapistToAccSession = async (TherapistId, AppDayId) => {
    let addReq = new AddManyToManyReq();
    addReq.Id1 = AccSession.id;
    addReq.Id2 = TherapistId;
    let res = await SessionsApi.AddTherapistToAccountingSession(addReq);
    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success").then(async () => {
        let getAccReq = new StringIntSearchReq();
        getAccReq.SearchInt = AccSession.id;
        var newAccSession = await SessionsApi.GetAccountingSessionById(getAccReq);
        SetAccSession(newAccSession.data);
      });
    } else {
      Swal.fire("Error", res.message, "error");
    }
  };

  const GetAppDay = async () => {
    let req = new GetAppointmentDayReq();
    req.dateDay = SearchDay;

    let res = await AppointmentsApi.GetAppoinmentDayByDate(req);

    if (res.status == "Success") {
      SetAppDay(res.data);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const GetSelectedAccSession = async (accSess) => {
    let req = new StringIntSearchReq();
    req.searchInt = accSess.id;
    let res = await SessionsApi.GetAccountingSessionById(req);

    if (res.status == "Success") {
      SetAccSession(res.data);
    }
  };
  const GetAccSessions = async () => {
    let accountingSessionReqs = new SearchAccountingSessions();

    accountingSessionReqs.id = AccSessionsSearch;
    accountingSessionReqs.patientId = Patient ? Patient.id : "";

    let res = await SessionsApi.SearchAccountingSessions(accountingSessionReqs);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({
          value: item,
          label: "ID: " + item.id + ",    Patient: " + item.getPatient.getUser.name,
          // + ",    Session: " + item.getSession.name
          // + ",    Paid?: " + item.isPaidFor ? "YES" : "NO"
        });
      });

      return optionsArr;
    }
  };

  const GetPatients = async () => {
    let usersReq = new SearchUserModel();
    usersReq.userType = "Patient";
    usersReq.name = PaitentsSearch;

    let res = await UsersApi.SearchUsers(usersReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item, label: item.name + ",  ID: " + item.id });
      });

      return optionsArr;
    }
  };

  const ShowAppDay = () => {
    if (!DayLoaded || Object.keys(AppDay).length < 1) {
      return <div>Day is not selected</div>;
    }

    const ShowTherapistInAccSession = (TherapistId) => {
      return Object.keys(AccSession).length < 1 ? (
        <MDTypography>Accounting Session is not Selected</MDTypography>
      ) : (
        <MDTypography>
          {AccSession.getTherapist && AccSession.getTherapist.id == TherapistId ? (
            "Therapist is in Accounting Session with Id= " + AccSession.id
          ) : (
            <>
              Therapist Not in Accounting Session with Id= AccSession.id
              {!AccSession.getTherapist && (
                <MDButton onClick={() => AddTherapistToAccSession(TherapistId)} variant="secondary">
                  Add Therapist To Selected Acc. Session
                </MDButton>
              )}
            </>
          )}
        </MDTypography>
      );
    };

    const ShowAccSessionTherapist = () => {
      if (Object.keys(AccSession) < 1) {
        return <div>Accounting Session Not Selected</div>;
      }

      if (!AccSession.getTherapist) {
        return (
          <MDTypography color="error">Accounting Session Does not have a Therapist</MDTypography>
        );
      }
      return (
        <MDBox>
          <MDBox>Therapist for Accounting Session with Id: {AccSession.id}</MDBox>
          <MDBox>
            {AppAccSessThObj &&
              Object.keys(AppAccSessThObj).length > 1 &&
              Object.keys(AccSession.getTherapist).length > 0 && (
                <MDBox>
                  <MDTypography>
                    TherapistId {AccSession.getTherapist.id}, Name:{" "}
                    {AccSession.getTherapist.getUser.name}
                  </MDTypography>
                  <MDTypography>
                    Is in Day?{" "}
                    {AppAccSessThObj.isIn ? (
                      "Yes"
                    ) : (
                      <>
                        <label>Therapist Not in Day</label>
                        <button
                          className="btn btn-dark"
                          onClick={() =>
                            AddTherapistToAppointmentDay(AccSession.getTherapist.id, AppDay.id)
                          }
                        >
                          Add {AccSession.getTherapist.getUser.name} To Day
                        </button>
                      </>
                    )}
                  </MDTypography>
                  <MDTypography>
                    Selected HourId:{" "}
                    {AppAccSessThObj.SelectedAppHour
                      ? AppAccSessThObj.SelectedAppHour.id
                      : "Not Selected"}
                  </MDTypography>
                </MDBox>
              )}
          </MDBox>
        </MDBox>
      );
    };

    const MakeSelectHourOptions = () => {
      var headerArr = [];
      for (let i = 0; i < 24; i++) {
        headerArr.push(<option value={i}>{i < 10 ? "0" + i + ":00" : i + ":00"}</option>);
      }

      return headerArr;
    };
    return (
      <div className="col-md-12 mt-3">
        {ShowAccSessionTherapist()}

        <MDTypography className="custom-card">
          <span>Day Id:</span> <p>{AppDay.id}</p>
        </MDTypography>

        <MDTypography className="custom-card">
          <span>Date:</span> <p>{AppDay.dateDay}</p>
        </MDTypography>

        <MDTypography className="custom-card">
          <span>Select hour:</span>
          <select onChange={(e) => SetSelectedHour(Number.parseInt(e.target.value))}>
            {MakeSelectHourOptions().map((o) => {
              return o;
            })}
          </select>
        </MDTypography>

        <MDTypography className="custom-card">
          <span>Therapists in Day:</span>
          <MDBox>
            {AppDay.getTherapists.map((t, index) => {
              return (
                <MDBox>
                  <MDTypography>
                    {index + 1}_ Therapist: {t.getTherapist.getUser.name}, Therapist Id:{" "}
                    {t.getTherapist.id}
                  </MDTypography>
                  {ShowTherapistInAccSession(t.therapistId)}
                </MDBox>
              );
            })}
          </MDBox>
        </MDTypography>
      </div>
    );
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="card">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                <label>
                  Patient Id (For AccSession Search) -- Auto Selected:{" "}
                  {Patient.getUser && Patient.getUser.name}
                </label>
              </MDTypography>
              {/* accountingSessionId */}

              <AsyncSelect
                isClearable={true}
                loadOptions={GetPatients}
                onInputChange={SetPatientsSearch}
                onChange={(e) => SetPatient(e ? e.value : "")}
              />
            </div>

            <div className="col-md-6">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                <label>
                  Accounting Session Id -- Auto Selected: ID:{" "}
                  {Object.keys(AccSession).length > 0 &&
                    AccSession.id + ", " + AccSession.getSession.name}
                </label>
              </MDTypography>
              {/* accountingSessionId */}

              <AsyncSelect
                isClearable={true}
                loadOptions={GetAccSessions}
                onInputChange={SetAccouningSessionsSearch}
                onChange={(e) => GetSelectedAccSession(e ? e.value : "")}
              />
            </div>

            <div className="col-md-6 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Appointment Time: &nbsp;
              </MDTypography>
              <button className="btn btn-primary mr-1" onClick={() => GetAppDay()}>
                Search Day
              </button>
              <DateTimePicker onChange={SetSearchDay} value={SearchDay} />
            </div>

            {ShowAppDay()}
          </div>
          <div className="row text-right mt-3">
            <button
              onClick={() => CreateAppointment()}
              className="btn btn-dark"
              disabled={!CreateIsReady}
            >
              Create Appointment
            </button>
            {ShowGoToHour && (
              <button onClick={() => GoToHour()} className="btn btn-dark">
                Go To Hour
              </button>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default index;
